import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export type SearchHitType =
  | "Cliente"
  | "Fornecedor"
  | "Subempreiteiro"
  | "Obra"
  | "Fatura";

export interface SearchHit {
  type: SearchHitType;
  id: number;
  title: string;
  subtitle?: string | null;
}

export interface GlobalSearchResult {
  hits: SearchHit[];
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  const text = await response.text();
  if (!text) {
    return { hits: [] } as T;
  }

  return JSON.parse(text) as T;
}

export function globalSearch(
  term: string,
  maxPerType?: number,
): Promise<GlobalSearchResult> {
  const query = new URLSearchParams({ term });
  if (maxPerType !== undefined) {
    query.set("maxPerType", maxPerType.toString());
  }

  return request<GlobalSearchResult>(`/api/search?${query.toString()}`);
}
